import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

export default class InvoiceItemModel extends Model {
  @attr() allocatedAmount;
  @belongsTo('invoice', { async: false }) invoice;
  @belongsTo('appointment', { async: false }) appointment;
  @belongsTo('appointment-client', { async: false }) appointmentClient;
  @hasMany('invoice-item', { async: false }) invoiceItems;
  @attr('number') price;
  @attr('number') remainingAmount;
  @attr('moment') issueDate;
}
